var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6211 41.1383C52.6211 42.8863 52.2768 44.6171 51.6079 46.232C50.9389 47.8469 49.9585 49.3143 48.7225 50.5503C47.4865 51.7863 46.0192 52.7667 44.4043 53.4356C42.7894 54.1045 41.0585 54.4488 39.3105 54.4488C35.7804 54.4488 32.3948 53.0465 29.8986 50.5503C27.4023 48.0541 26 44.6685 26 41.1383C26 37.6081 27.4023 34.2225 29.8986 31.7263C32.3948 29.2301 35.7804 27.8278 39.3105 27.8278C42.8407 27.8278 46.2263 29.2301 48.7225 31.7263C51.2187 34.2225 52.6211 37.6081 52.6211 41.1383V41.1383Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1113 31.3105C66.1113 34.8407 64.709 38.2263 62.2128 40.7225C59.7165 43.2187 56.3309 44.6211 52.8008 44.6211C49.2706 44.6211 45.885 43.2187 43.3888 40.7225C40.8926 38.2263 39.4902 34.8407 39.4902 31.3105C39.4902 29.5626 39.8345 27.8317 40.5034 26.2168C41.1724 24.6019 42.1528 23.1345 43.3888 21.8986C44.6248 20.6626 46.0921 19.6821 47.707 19.0132C49.3219 18.3443 51.0528 18 52.8008 18C56.3309 18 59.7165 19.4023 62.2128 21.8986C64.709 24.3948 66.1113 27.7804 66.1113 31.3105V31.3105Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3252 56.8085C74.3252 60.3386 72.9228 63.7242 70.4266 66.2204C67.9304 68.7167 64.5448 70.119 61.0146 70.119C59.2667 70.119 57.5358 69.7747 55.9209 69.1058C54.306 68.4369 52.8387 67.4564 51.6027 66.2204C50.3667 64.9844 49.3862 63.5171 48.7173 61.9022C48.0484 60.2873 47.7041 58.5564 47.7041 56.8085C47.7041 53.2783 49.1064 49.8927 51.6027 47.3965C54.0989 44.9003 57.4845 43.4979 61.0146 43.4979C64.5448 43.4979 67.9304 44.9003 70.4266 47.3965C72.9228 49.8927 74.3252 53.2783 74.3252 56.8085V56.8085Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.459 40.9791C79.459 42.7271 79.1147 44.4579 78.4458 46.0728C77.7769 47.6878 76.7964 49.1551 75.5604 50.3911C74.3244 51.6271 72.8571 52.6075 71.2422 53.2764C69.6272 53.9454 67.8964 54.2896 66.1484 54.2896C64.4005 54.2896 62.6696 53.9454 61.0547 53.2764C59.4398 52.6075 57.9724 51.6271 56.7364 50.3911C55.5004 49.1551 54.52 47.6878 53.8511 46.0728C53.1821 44.4579 52.8379 42.7271 52.8379 40.9791C52.8379 39.2311 53.1821 37.5003 53.8511 35.8854C54.52 34.2705 55.5004 32.8031 56.7364 31.5671C57.9724 30.3311 59.4398 29.3507 61.0547 28.6817C62.6696 28.0128 64.4005 27.6686 66.1484 27.6686C67.8964 27.6686 69.6272 28.0128 71.2422 28.6817C72.8571 29.3507 74.3244 30.3311 75.5604 31.5671C76.7964 32.8031 77.7769 34.2705 78.4458 35.8854C79.1147 37.5003 79.459 39.2311 79.459 40.9791V40.9791Z",
    stroke: "url(#paint3_linear)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7256 56.894C57.7256 58.642 57.3813 60.3729 56.7124 61.9878C56.0435 63.6027 55.063 65.07 53.827 66.306C52.591 67.542 51.1237 68.5224 49.5088 69.1914C47.8938 69.8603 46.163 70.2046 44.415 70.2046C42.6671 70.2046 40.9362 69.8603 39.3213 69.1914C37.7064 68.5224 36.239 67.542 35.003 66.306C33.767 65.07 32.7866 63.6027 32.1177 61.9878C31.4488 60.3729 31.1045 58.642 31.1045 56.894C31.1045 55.1461 31.4488 53.4152 32.1177 51.8003C32.7866 50.1854 33.767 48.718 35.003 47.482C36.239 46.246 37.7064 45.2656 39.3213 44.5967C40.9362 43.9277 42.6671 43.5835 44.415 43.5835C46.163 43.5835 47.8938 43.9277 49.5088 44.5967C51.1237 45.2656 52.591 46.246 53.827 47.482C55.063 48.718 56.0435 50.1854 56.7124 51.8003C57.3813 53.4152 57.7256 55.1461 57.7256 56.894Z",
    stroke: "url(#paint4_linear)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 105.459,
    height: 104.205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.788235 0 0 0 0 0.854902 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 35.4996,
    y1: 33.3738,
    x2: 58.738,
    y2: 37.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.9899,
    y1: 23.5461,
    x2: 72.2283,
    y2: 28.0106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 57.2037,
    y1: 49.044,
    x2: 80.4421,
    y2: 53.5085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 62.3375,
    y1: 33.2146,
    x2: 85.5759,
    y2: 37.6792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 40.6041,
    y1: 49.1296,
    x2: 63.8425,
    y2: 53.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58F0F0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionImg3);
export default __webpack_public_path__ + "static/media/AboutSectionImg3.05f4864a.svg";
export { ForwardRef as ReactComponent };